import React from "react";

import DataTableColumnHeader from "../../dataTable/DataTableColumnHeader";
import { dateColumn, dateTimeColumn } from "../../dataTable/dataTableColumns";

import type { TFunction } from "i18next";

import type { FreecopyBatchItem } from "../../../api/OfferAPI.types";
import type { DataTableColumnDef } from "../../dataTable/dataTable.types";

interface FreecopyBatchColumnsOptions {
  t: TFunction;
}

export function freecopyBatchColumns({
  t,
}: FreecopyBatchColumnsOptions): DataTableColumnDef<FreecopyBatchItem>[] {
  return [
    {
      accessorKey: "label",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("label")} />
      ),
      meta: { searchable: true, label: t("label") },
      cell: ({ row }) => row.original.label,
    },
    {
      accessorKey: "count",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("count")} />
      ),
      meta: {
        label: t("count"),
        width: "14%",
        minWidth: 110,
        align: "center",
      },
    },
    dateColumn<FreecopyBatchItem>("inserted_at", t("insertedAt"), {
      width: "12%",
      minWidth: 150,
    }),
    {
      accessorKey: "activated",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("activationCount")} />
      ),
      meta: {
        label: t("activationCount"),
        width: "14%",
        minWidth: 135,
        align: "center",
      },
    },
    dateTimeColumn<FreecopyBatchItem>("updated_at", t("updatedAt"), {
      width: "17%",
      minWidth: 210,
    }),
  ];
}
